"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnboaredPageLoader = exports.UnboaredActivityIndicator = void 0;
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const base_ui_all_1 = require("@unboared/base-ui.all");
const design_timer_stopwatches_1 = require("@unboared/design.timer.stopwatches");
const unboared_light_1 = require("./unboared_light");
const base_activity_indicator_1 = require("../base_activity_indicator");
const SIZE_LOADER = 240;
const SPEED_LOADER = 0.8;
const UnboaredActivityIndicator = ({ infos, size, strokeWidth = 6, style, textStyle, }) => {
    const { normalize } = (0, base_ui_all_1.useNormalize)();
    const { time, start } = (0, design_timer_stopwatches_1.useStopwatch)();
    (0, react_1.useEffect)(() => {
        start();
    }, []);
    const YellowLightSVG = (react_1.default.createElement(unboared_light_1.UnboaredLight, { angle: SPEED_LOADER * time, color: "#f3ca20", size: normalize(size || SIZE_LOADER), strokeWidth: normalize(strokeWidth) }));
    const RedLightSVG = (react_1.default.createElement(unboared_light_1.UnboaredLight, { angle: -SPEED_LOADER * time, color: "#FF2354", size: normalize(size || SIZE_LOADER), strokeWidth: normalize(strokeWidth) }));
    return (react_1.default.createElement(base_activity_indicator_1.BaseActivityIndicator, { infos: infos, style: style, textStyle: textStyle },
        react_1.default.createElement(react_native_1.View, null,
            YellowLightSVG,
            react_1.default.createElement(react_native_1.View, { style: { position: 'absolute' } }, RedLightSVG))));
};
exports.UnboaredActivityIndicator = UnboaredActivityIndicator;
exports.UnboaredPageLoader = exports.UnboaredActivityIndicator;
//# sourceMappingURL=unboared_activity_indicator.js.map